// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { Workspace } from '../types';
import { createQueryKey } from '../utils/keys';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const uploadImageMutationKey = ['uploadImage'] as const;
export const putWorkspaceOrganizationIdMutationKey = [
  'putWorkspaceOrganizationId',
] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getWorkspaceQueryKey = (workspaceId: number) =>
  createQueryKey<Workspace>()(['workspaces', workspaceId] as const);
